import { useFieldArray, useFormContext } from "react-hook-form";
import useTranslations from "../../core/i18n/useTranslations";
import { Spacer } from "../Layout/Layout";
import { IObservationIndetifiersBulkNew } from "../../core/api/observationIdentifiers/types";
import { Button } from "../../ui-lib/components/Button/Button";
import { Fragment } from "react/jsx-runtime";
import ObservationIdentifierRow from "./ObservationIdentifierRow";
import { getDefaultRowValues } from "./helpers";

type ObservationIdentifierBlockProps = {
  required?: boolean;
  hasLocation?: boolean;
};

const ObservationIdentifierRowsSet = ({
  required = true,
  hasLocation = true,
}: ObservationIdentifierBlockProps) => {
  const t = useTranslations();
  const methods = useFormContext<IObservationIndetifiersBulkNew>();
  const {
    trigger,
    formState: { errors },
    getValues,
    control,
  } = methods;

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: "dataDefinitions",
  });
  const defaultValues = getDefaultRowValues();

  const isAddNewRowDisabled = () =>
    getValues("dataDefinitions")?.some((row) => !row.macAddress.trim()) ||
    errors.dataDefinitions !== undefined;

  const onAddNewRow = async () => {
    const valid = await trigger("dataDefinitions");
    if (valid) {
      append({
        ...defaultValues,
      });
    }
  };

  return (
    <>
      {fields.map((oi, index) => (
        <Fragment key={`oi_${oi.id}`}>
          <ObservationIdentifierRow<IObservationIndetifiersBulkNew>
            base="dataDefinitions"
            index={index}
            required={required}
            showDeleteButton={fields.length > 1}
            onDelete={() => remove(index)}
            hasLocation={hasLocation}
          />
          <Spacer size={16} />
        </Fragment>
      ))}
      <Button
        text={t("Locations:oi_add_identifier")}
        image="plus"
        variant="secondary"
        disabled={isAddNewRowDisabled()}
        onClick={onAddNewRow}
      />
    </>
  );
};

export default ObservationIdentifierRowsSet;
